import { Button, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useContextUsers } from '../../../../../context/users';
import { useCancelSubscription, useResumeSubscription, useSubscriptionId } from '../../../../../hooks/stripe';
import ContentCard from '../../../../Common/ContentCard';
import CancelModal from './CancelModal';
import { CancelSubscriptionForm } from './CancelModal/CancelReasonStep/config';
import { useAuth } from '../../../../../context/auth';

const CancelSubscription = () => {
  const { profile, getProfile } = useContextUsers();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const subscriptionId = useSubscriptionId();
  const { fetch, loading } = useCancelSubscription();
  const resumeSubscription = useResumeSubscription();

  const { setSubscriptionData } = useAuth();

  const subscription = subscriptionId?.data?.data;
  const subscriptionCancelAt = subscription?.cancel_at;

  useEffect(() => {
    subscriptionId.fetch(undefined, profile?.subscriptionId as string)
  }, [profile]);

  const handleCancelSubscription = (data: CancelSubscriptionForm) => {
    if (!profile?.subscriptionId || !getProfile) return;

    const body: CancelSubscriptionForm & { userEmail: string; fullName: string } = {
      ...data,
      userEmail: profile?.email,
      fullName: [profile?.firstName, profile?.lastName].filter(Boolean).join(' ')
    }

    setIsModalOpen(false);
    fetch(body, profile?.subscriptionId).then(() => {
      // setSubscriptionData({ isActive: false, subscriptionId: null })
      getProfile()
    });
  };

  const handleOpenCancelModal = () => {
    setIsModalOpen(true);
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
  };

  const handleResumeSubscription = () => {
    if (!profile?.subscriptionId || !getProfile) return;

    resumeSubscription.fetch(undefined, profile?.subscriptionId).then(() => {
      getProfile()
    })
  }

  return (
    <ContentCard
      bordered
      padding={20}
      footer={
        <Button
          className="btn-default-dark-blue"
          type="default"
          size="large"
          onClick={subscriptionCancelAt ? handleResumeSubscription : handleOpenCancelModal}
          loading={loading || resumeSubscription?.loading}
        >
          {subscriptionCancelAt ? 'Resume My Subscription' : 'Cancel'}
        </Button>
      }
    >
      <CancelModal open={isModalOpen} onCancel={handleModalCancel} onOk={handleCancelSubscription} />
      <div className="flex-col gap-16">
        <Typography.Text className="fs-1 fw-600">
          {subscriptionCancelAt ?
            'Changed your mind? Reactivate now to keep your account active and avoid losing access.' :
            'Considering ending your subscription?'}
        </Typography.Text>
        {!subscriptionCancelAt && (
          <Typography.Text className="color-gray">
            Please be aware that if you choose to terminate your subscription, it will stay active until the conclusion
            of your current billing cycle. We reserve the right delete your account and remove your data from our
            servers after 90 days from your cancellation date. This encompasses all information tied to your account,
            which includes but is not limited to, report links, usage history, referrals, and analytics.
          </Typography.Text>
        )}
      </div>
    </ContentCard>
  );
};

export default CancelSubscription;
